import { PORTAL_ROUTE } from 'src/constants/routes';

export const getDeploymentRingDetailsRoute = ringId =>
  `${PORTAL_ROUTE}/deployment-ring-details/${ringId}/general`;

export const deploymentRingDetailsTabs = ringId => [
  {
    label: 'General',
    value: getDeploymentRingDetailsRoute(ringId),
  },
  {
    label: 'Devices',
    value: `${PORTAL_ROUTE}/deployment-ring-details/${ringId}/devices`,
  },
];
